import dayjs from "dayjs";

const DateDisplay = (props: any) => {
    const date: Date = props.date;
    return (<span className="font-light text-gray-600">{dayjs(date).format('DD/MM/YYYY')}</span>)
}

export default DateDisplay;